// Domain 07 — Infrastructure Management (RouteZero Network Operations Center, Iloilo City)
import u01 from './u01-ios-modes.js';
import u02 from './u02-verification.js';
import u03 from './u03-run-vs-start.js';
import u04 from './u04-backup-restore.js';
import u05 from './u05-ios-images.js';
import u06 from './u06-ios-upgrade.js';
import u07 from './u07-boot-recovery.js';
import u08 from './u08-cdp-lldp.js';
import u09 from './u09-syslog-ntp.js';
import u10 from './u10-snmp-health.js';
import u11 from './u11-documentation.js';
import u12 from './u12-change-rollback.js';
import u13 from './u13-automation.js';
import u14 from './u14-final.js';

export default {
  id: 'd07', number: '07', title: 'Infrastructure Management',
  tagline: 'IOS operation and verification, configuration backup and restore, simulated IOS upgrades and boot recovery, CDP/LLDP, NTP, syslog and SNMP monitoring, documentation, change management and automation concepts at RouteZero\'s Iloilo NOC.',
  units: [u01, u02, u03, u04, u05, u06, u07, u08, u09, u10, u11, u12, u13, u14],
};
